import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './profile-page.css';

// 极其优美的内联 SVG 图标组件
const SocialIcon = ({ type }) => {
    switch (type) {
        case 'instagram':
            return (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6A7180" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
            );
        case 'twitter':
        case 'x':
            return (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="#6A7180">
                    <path d="M18.244 2.25h3.308l-7.227 7.719 8.502 11.24H16.17l-5.214-6.817L4.99 21.25H1.68l7.73-8.235L1.254 2.25H8.08l4.713 6.231zm-1.161 17.02h1.833L7.084 4.126H5.117z" />
                </svg>
            );
        case 'youtube':
            return (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6A7180" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
                    <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="#6A7180" />
                </svg>
            );
        case 'tiktok':
            return (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6A7180" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                </svg>
            );
        case 'linkedin':
            return (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#6A7180">
                    <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.13 2.07 2.07 0 0 1 0 4.13zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.55C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.72C24 .77 23.2 0 22.22 0z" />
                </svg>
            );
        case 'globe':
            return (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6A7180" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
            );
        default:
            return null;
    }
};

// 完美且高保真的群聊头像组组件 - 严格对齐 iOS 布局
const GroupchatAvatarView = ({ hostAvatar, memberAvatars = [] }) => {
    const totalAvatars = [hostAvatar, ...memberAvatars].filter(url => url && url.length > 0);
    const totalCount = totalAvatars.length;

    const renderAvatarImg = (url, extraClass = '') => {
        return (
            <div className={`groupchat-avatar-cell ${extraClass}`}>
                {url ? (
                    <img src={url} alt="Avatar" onError={(e) => { e.target.style.display = 'none'; }} />
                ) : (
                    <div className="groupchat-avatar-fallback"></div>
                )}
            </div>
        );
    };

    if (totalCount === 0) {
        return (
            <div className="groupchat-avatar-view layout-1">
                {renderAvatarImg(null)}
            </div>
        );
    }

    if (totalCount === 1) {
        return (
            <div className="groupchat-avatar-view layout-1">
                {renderAvatarImg(totalAvatars[0])}
            </div>
        );
    }

    if (totalCount === 2) {
        return (
            <div className="groupchat-avatar-view layout-2">
                {renderAvatarImg(totalAvatars[0], 'left')}
                {renderAvatarImg(totalAvatars[1], 'right')}
            </div>
        );
    }

    if (totalCount === 3) {
        return (
            <div className="groupchat-avatar-view layout-3">
                {renderAvatarImg(totalAvatars[0], 'left-half')}
                <div className="right-half-vstack">
                    {renderAvatarImg(totalAvatars[1], 'top-right')}
                    {renderAvatarImg(totalAvatars[2], 'bottom-right')}
                </div>
            </div>
        );
    }

    return (
        <div className="groupchat-avatar-view layout-4">
            <div className="avatar-grid-row">
                {renderAvatarImg(totalAvatars[0], 'grid-cell')}
                {renderAvatarImg(totalAvatars[1], 'grid-cell')}
            </div>
            <div className="avatar-grid-row">
                {renderAvatarImg(totalAvatars[2], 'grid-cell')}
                {renderAvatarImg(totalAvatars[3], 'grid-cell')}
            </div>
        </div>
    );
};

// 清洗社交媒体账号，去除首尾空格、中间空格、及开头的 @ 符号
const cleanSocialHandle = (handle) => {
    if (!handle) return '';
    let cleaned = handle.trim();
    if (cleaned.startsWith('@')) {
        cleaned = cleaned.substring(1);
    }
    return cleaned.replace(/\s+/g, '');
};

export default function ProfilePage() {
    const { id } = useParams();
    const location = useLocation();
    // 该页同时服务 /profile/:id 与线下扫码的 /met/:id；met 进来时进页面自动唤起 App 并走 met 深链（唤起后 App 会建立 Met 关系）
    const isMet = location.pathname.startsWith('/met/');
    const [loading, setLoading] = useState(true);
    const [profileData, setProfileData] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0); // 0: Deals, 1: Events
    const touchStartX = useRef(null); // 大图轮播横滑起点
    const [interestsContent, setInterestsContent] = useState([]); // 后端配置的 Interests 文案表（int -> string）
    const [pronounsContent, setPronounsContent] = useState([]); // 后端配置的 Pronoun 文案表（int -> string）
    const [coverIndex, setCoverIndex] = useState(0); // 普通用户大图轮播当前页

    useEffect(() => {
        // 拉取全局配置，用于把用户 interests 的数字索引映射为文案（与 iOS Cache.configuration 一致）
        axios.get('/api/v1/configurations/0')
            .then(res => {
                const responseData = res.data || {};
                const realData = responseData.data || responseData.Data;
                const interests = realData?.Interests || realData?.interests;
                const content = interests?.Content || interests?.content;
                if (Array.isArray(content)) {
                    setInterestsContent(content);
                }
                const pronouns = realData?.Pronouns || realData?.pronouns;
                const pronounContent = pronouns?.Content || pronouns?.content;
                if (Array.isArray(pronounContent)) {
                    setPronounsContent(pronounContent);
                }
            })
            .catch(() => { });
    }, []);

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/v1/html/profile/${id}`)
            .then(res => {
                const responseData = res.data || {};
                const isSucceed = responseData.succeed !== undefined ? responseData.succeed : responseData.Succeed;
                const realData = responseData.data || responseData.Data;
                const realMessage = responseData.message || responseData.Message;

                if (res.status === 200 && isSucceed) {
                    setProfileData(realData);
                    document.title = `${realData?.user?.FirstName || 'Host'} - Profile`;
                } else {
                    console.error("Failed to load profile data:", realMessage);
                }
            })
            .catch(err => {
                console.error("Error loading profile:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    // 线下扫 Met 码进入 /met/:id 时，进页面自动尝试唤起 App（装了→直接进 App 建立 Met 并打开对方主页；没装→留在网页展示对方主页）
    useEffect(() => {
        if (!isMet) return;
        // 微信内无法唤起外部 App，直接展示网页即可
        if (/micromessenger/i.test(navigator.userAgent)) return;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = `marlo://met/${id}`;
        document.body.appendChild(iframe);
        const timer = setTimeout(() => {
            try { document.body.removeChild(iframe); } catch (e) {}
        }, 1500);
        return () => {
            clearTimeout(timer);
            try { document.body.removeChild(iframe); } catch (e) {}
        };
    }, [isMet, id]);

    const formatCount = (count) => {
        if (!count) return '0';
        if (count >= 1000000) {
            return (count / 1000000).toFixed(1) + 'M';
        }
        if (count >= 1000) {
            return (count / 1000).toFixed(1) + 'K';
        }
        return count.toString();
    };

    const calculateDaysLeft = (expiredAt, isFake) => {
        if (isFake) {
            return { display: "3 days left", isExpired: false };
        }
        if (!expiredAt) return { display: "3 days left", isExpired: false };
        const expired = new Date(expiredAt);
        const now = new Date();
        const diffTime = expired - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const isExpired = diffDays <= 0;
        return { display: diffDays > 0 ? `${diffDays} days left` : "Expired", isExpired };
    };

    // 与 iOS UserModel.interetArray 一致：CSV 索引 -> 文案，并过滤掉纯字母开头的分类标题项
    const getInterestArray = (interests) => {
        if (!interests || interestsContent.length === 0) return [];
        return interests.split(',')
            .map(s => interestsContent[parseInt(s, 10)] || '')
            .filter(text => text && !/^[A-Z]/.test(text));
    };

    // 渲染骨架屏 (Skeleton Loading)
    if (loading) {
        return (
            <div className="profile-container">
                <Header />
                <div className="profile-content">
                    {/* Header Block in skeleton */}
                    <div className="profile-header-section">
                        <div className="profile-skeleton profile-skeleton-avatar"></div>
                        <div className="profile-name-container">
                            <div className="profile-skeleton profile-skeleton-title"></div>
                            <div className="profile-skeleton profile-skeleton-subtitle" style={{ marginTop: '8px' }}></div>
                        </div>
                    </div>
                    <div className="profile-skeleton" style={{ width: '200px', height: '22px' }}></div>
                    <div className="profile-cards-grid" style={{ marginTop: '8px' }}>
                        <div className="profile-skeleton profile-skeleton-card" style={{ flex: 1 }}></div>
                        <div className="profile-skeleton profile-skeleton-card" style={{ flex: 1 }}></div>
                    </div>
                    <div className="profile-skeleton" style={{ width: '100%', height: '40px', marginTop: '12px' }}></div>
                    <div className="profile-skeleton" style={{ width: '100%', height: '120px', marginTop: '12px' }}></div>
                </div>
                <Footer />
            </div>
        );
    }

    // 若无数据
    const isBusiness = profileData?.user?.IsBusinessUser;
    if (!profileData || !profileData.user) {
        return (
            <div className="profile-container">
                <Header />
                <div className="profile-no-user-content">
                    <img 
                        src={require('../images/nothing.png')} 
                        alt="No Signal" 
                        className="profile-no-user-image"
                    />
                    <p className="profile-no-user-text">No Signal</p>
                </div>
                <Footer />
            </div>
        );
    }

    const { user, followerCount, followingCount, waves = [] } = profileData;

    // 根据 iOS 逻辑筛选和分类活动 (Hosted Events)
    const activeWaves = waves.filter(wave => {
        if (wave.IsFake) return true;
        if (!wave.ExpiredAt) return true;
        const expired = new Date(wave.ExpiredAt);
        const now = new Date();
        return expired > now; // 只过滤未过期的活动/Deals
    });

    const deals = activeWaves.filter(wave => !wave.IsExplore);
    const events = activeWaves.filter(wave => wave.IsExplore);

    const hasBoth = deals.length > 0 && events.length > 0;
    const hasOnlyDeals = deals.length > 0 && events.length === 0;
    const hasOnlyEvents = events.length > 0 && deals.length === 0;

    const displayWaves = hasBoth 
        ? (selectedTab === 0 ? deals : events) 
        : (deals.length === 0 ? events : deals);

    // 唤起 App：装了→打开 App；没装→弹页内下载弹框（二维码+App Store，不刷新页面）
    // met 场景走 met 深链，App 唤起后会建立 Met 关系并打开对方主页；profile 场景仅打开主页
    const handleOpenInApp = () => {
        const isWeChat = /micromessenger/i.test(navigator.userAgent);

        const urlScheme = isMet ? `marlo://met/${id}` : `marlo://profile/${id}`;

        if (isWeChat) {
            // 微信无法唤起外部 App，直接弹下载弹框
            window.dispatchEvent(new Event('openDownloadModal'));
            return;
        }

        // 先用隐藏 iframe 试 URL Scheme（失败不会弹“网址无效”也不会刷新当前页）
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = urlScheme;
        document.body.appendChild(iframe);

        // 350ms 后若页面仍在前台，说明没装 App：弹出下载弹框
        setTimeout(() => {
            try { document.body.removeChild(iframe); } catch (e) {}
            if (!document.hidden) {
                window.dispatchEvent(new Event('openDownloadModal'));
            }
        }, 350);
    };

    // ============ 普通用户 Profile（对齐 iOS 改版后的 ProfilePage：大图轮播 + 名字 + 标签 + Interests/Socials + Hosted Events） ============
    if (!isBusiness) {
        const interestArray = getInterestArray(user.Interests);
        // c 端不展示 Website（与 iOS 一致），只展示 Instagram / X / YouTube / TikTok
        const socials = [
            user.InstagramAccount && {
                type: 'instagram',
                handle: cleanSocialHandle(user.InstagramAccount),
                url: `https://www.instagram.com/${cleanSocialHandle(user.InstagramAccount)}`,
            },
            user.TwitterAccount && {
                type: 'x',
                handle: cleanSocialHandle(user.TwitterAccount),
                url: `https://twitter.com/${cleanSocialHandle(user.TwitterAccount)}`,
            },
            user.YoutubeAccount && {
                type: 'youtube',
                handle: cleanSocialHandle(user.YoutubeAccount),
                url: user.YoutubeAccount.startsWith('http')
                    ? user.YoutubeAccount.trim().replace(/\s+/g, '')
                    : `https://www.youtube.com/@${cleanSocialHandle(user.YoutubeAccount)}`,
            },
            user.TiktokAccount && {
                type: 'tiktok',
                handle: cleanSocialHandle(user.TiktokAccount),
                url: `https://www.tiktok.com/@${cleanSocialHandle(user.TiktokAccount)}`,
            },
        ].filter(Boolean);

        // 大图：优先 CoverImages，老用户回落到头像；私密账号只展示头像
        const allCovers = (user.CoverImages && user.CoverImages.length > 0)
            ? user.CoverImages
            : (user.ProfilePicture ? [user.ProfilePicture] : []);
        const covers = user.IsPrivate ? allCovers.slice(0, 1) : allCovers;
        const safeIndex = covers.length > 0 ? Math.min(coverIndex, covers.length - 1) : 0;

        return (
            <div className="profile-container">
                <Header />

                {/* 1. 顶部大图轮播（深色底 + 底部渐变 + 页码点） */}
                <div className="pu-hero">
                    <div
                        className="pu-hero-inner"
                        onTouchStart={(e) => { touchStartX.current = e.touches[0].clientX; }}
                        onTouchEnd={(e) => {
                            if (touchStartX.current === null || covers.length < 2) return;
                            const delta = e.changedTouches[0].clientX - touchStartX.current;
                            touchStartX.current = null;
                            if (Math.abs(delta) < 40) return;
                            const next = delta < 0 ? safeIndex + 1 : safeIndex - 1;
                            setCoverIndex(Math.min(covers.length - 1, Math.max(0, next)));
                        }}
                    >
                        {covers.length > 0 ? (
                            <img className="pu-hero-image" src={covers[safeIndex]} alt="Profile" />
                        ) : (
                            /* 没传过照片的老用户：用个人默认背景图，与 App 同一张 */
                            <img
                                className="pu-hero-image"
                                src={require('../images/DefaultProfileBG.png')}
                                alt="Profile"
                            />
                        )}
                        <div className="pu-hero-gradient"></div>
                        {covers.length > 1 && (
                            <div className="pu-hero-dots">
                                {covers.map((_, i) => (
                                    <span
                                        key={i}
                                        className={`pu-hero-dot ${i === safeIndex ? 'active' : ''}`}
                                        onClick={() => setCoverIndex(i)}
                                    ></span>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="profile-content pu-content">
                    {/* 2. 名字 + @username */}
                    <div className="pu-name-block" onClick={handleOpenInApp} style={{ cursor: 'pointer' }}>
                        <h1 className="pu-name">{user.FirstName ? user.FirstName : `@${user.Username || 'User'}`}</h1>
                        {user.Username && <p className="pu-username">@{user.Username}</p>}
                    </div>

                    {/* 3. 星座 + 性别标签（MBTI 按需求下掉） */}
                    {(() => {
                        // 配置表首项是 None，0 表示未填写
                        const pronounText = user.Pronoun > 0 ? (pronounsContent[user.Pronoun] || '') : '';
                        const tags = [user.ZodiacSign, pronounText].filter(Boolean);
                        if (tags.length === 0) return null;
                        return (
                            <div className="pu-tags-row">
                                {tags.map((text) => (
                                    <span className="pu-tag" key={text}>{text}</span>
                                ))}
                            </div>
                        );
                    })()}

                    {/* 4. Bio */}
                    {user.BioText && <p className="pu-bio">{user.BioText}</p>}

                    {/* 5. Following */}
                    <div className="pu-stats-row" onClick={handleOpenInApp} style={{ cursor: 'pointer' }}>
                        <span className="pu-stat-count">{formatCount(followingCount)}</span>
                        <span className="pu-stat-label">Following</span>
                    </div>

                    {user.IsPrivate ? (
                        <>
                            <div className="pu-divider"></div>
                            <div className="profile-private-section">
                                <img
                                    src={require('../images/PrivateAccount.png')}
                                    alt="Private"
                                    className="profile-private-image"
                                />
                                <div className="profile-private-text-container">
                                    <h3 className="profile-private-title">Private Account</h3>
                                    <p className="profile-private-subtitle">Follow to request access to their events and contact details.</p>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* 6. My Interests */}
                            {interestArray.length > 0 && (
                                <>
                                    <div className="pu-divider"></div>
                                    <div className="pu-section">
                                        <p className="pu-section-title">My Interests</p>
                                        <div className="pu-chips-wrap">
                                            {interestArray.map((text, i) => (
                                                <span className="pu-interest-chip" key={i}>{text}</span>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* 7. My Socials */}
                            {socials.length > 0 && (
                                <>
                                    <div className="pu-divider"></div>
                                    <div className="pu-section">
                                        <p className="pu-section-title">My Socials</p>
                                        <div className="pu-chips-wrap">
                                            {socials.map((item) => (
                                                <span
                                                    className="pu-social-chip"
                                                    key={item.type}
                                                    onClick={() => window.open(item.url, '_blank')}
                                                >
                                                    <SocialIcon type={item.type} />
                                                    <span className="pu-social-text">@{item.handle}</span>
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* 8. Hosted Events */}
                            {activeWaves.length > 0 ? (
                                <>
                                    <div className="pu-divider"></div>
                                    <div className="profile-events-section">
                                        <div className="profile-events-title-container">
                                            <span style={{ fontSize: '18px' }}>📢</span>
                                            <h2 className="profile-events-title">Hosted Events</h2>
                                            <span className="profile-events-count">({activeWaves.length})</span>
                                        </div>

                                        <div className="profile-events-list">
                                            {activeWaves.map((wave, idx) => {
                                                const colorClasses = ['color-green', 'color-purple', 'color-yellow'];
                                                const colorClass = colorClasses[idx % colorClasses.length];

                                                return (
                                                    <React.Fragment key={wave.ID}>
                                                        <a className="profile-event-card" href={`/event/${wave.ID}`}>
                                                            <div className="profile-event-image-container">
                                                                <div className={`profile-event-fallback-container ${colorClass}`}>
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#AADA3F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                                        <line x1="16" y1="2" x2="16" y2="6" />
                                                                        <line x1="8" y1="2" x2="8" y2="6" />
                                                                        <line x1="3" y1="10" x2="21" y2="10" />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                            <div className="profile-event-details">
                                                                <h3 className="profile-event-title-text">{wave.Title}</h3>
                                                                <div className="profile-event-tags-row">
                                                                    {wave.Distence && wave.Distence.string && (
                                                                        <div className="profile-event-tag">
                                                                            <span className="profile-event-tag-icon">
                                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA4B1" strokeWidth="2">
                                                                                    <path d="M12 2a8 8 0 0 0-8 8c0 5.25 8 12 8 12s8-6.75 8-12a8 8 0 0 0-8-8z" />
                                                                                </svg>
                                                                            </span>
                                                                            <span className="profile-event-tag-text">{wave.Distence.string}</span>
                                                                        </div>
                                                                    )}
                                                                    <div className="profile-event-tag">
                                                                        <span className="profile-event-tag-icon">
                                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA4B1" strokeWidth="2">
                                                                                <circle cx="12" cy="12" r="10" />
                                                                                <polyline points="12 6 12 12 16 14" />
                                                                            </svg>
                                                                        </span>
                                                                        <span className="profile-event-tag-text">
                                                                            {calculateDaysLeft(wave.ExpiredAt, wave.IsFake).display}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        {idx < activeWaves.length - 1 && <div className="profile-event-divider"></div>}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="profile-empty-events-state">
                                    <img
                                        src={require('../images/NoEventsPostedYet.png')}
                                        alt="No events"
                                        className="profile-empty-events-image"
                                    />
                                    <p className="profile-empty-events-text">Nothing posted yet.</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="profile-container">
            <Header />
            <div className="profile-content">
                {/* 1. Header Section (Frame 1556237957 - Avatar & Name Row) */}
                <div className="profile-header-section" onClick={handleOpenInApp} style={{ cursor: 'pointer' }}>
                    <div className="profile-avatar-container">
                        {user.ProfilePicture ? (
                            <img 
                                className="profile-avatar-image" 
                                src={user.ProfilePicture} 
                                alt="User Avatar"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                        ) : null}
                        <div 
                            className="profile-avatar-placeholder"
                            style={{ display: user.ProfilePicture ? 'none' : 'block' }}
                        ></div>
                    </div>
                    <div className="profile-name-container">
                        <h1 className="profile-display-name">
                            {user.FirstName ? `${user.FirstName}` : `@${user.Username || 'User'}`}
                        </h1>
                        <p className="profile-handle-name">
                            @{user.Username || 'User'}
                        </p>
                    </div>
                </div>

                {/* 2. Stats Row (Frame 1556238078 - Following / Followers Stats) */}
                <div className="profile-stats-row" onClick={handleOpenInApp} style={{ cursor: 'pointer' }}>
                    <div className="profile-stat-item">
                        <span className="profile-stat-count">{formatCount(followingCount)}</span>
                        <span className="profile-stat-label">Following</span>
                    </div>
                    <div className="profile-stat-divider"></div>
                    <div className="profile-stat-item">
                        <span className="profile-stat-count">{formatCount(followerCount)}</span>
                        <span className="profile-stat-label">Followers</span>
                    </div>
                </div>

                {/* Conditional Rendering based on isPrivate */}
                {user.IsPrivate ? (
                    /* 私人账户视角 - 严格对齐 iOS 布局 */
                    <>
                        {/* 6. Action Buttons Row (仅显示 Follow 按钮) */}
                        <div className="profile-actions-row private-mode">
                            <button className="profile-action-btn follow full-width" onClick={handleOpenInApp}>Follow</button>
                        </div>

                        {/* Divider */}
                        <div className="profile-info-divider"></div>

                        {/* Private Account Section */}
                        <div className="profile-private-section">
                            <img 
                                src={require('../images/PrivateAccount.png')} 
                                alt="Private" 
                                className="profile-private-image"
                            />
                            <div className="profile-private-text-container">
                                <h3 className="profile-private-title">Private Account</h3>
                                <p className="profile-private-subtitle">Follow to request access to their events and contact details.</p>
                            </div>
                        </div>
                    </>
                ) : (
                    /* 公开账户视角 */
                    <>
                        {/* 3. Double Card Row (Frame 1556237959 - Groupchat & Support Cards) */}
                        {(user.EnableGroupchat || user.SupportLink) && (
                            <div className="profile-cards-grid">
                                {/* Community Chat Card */}
                                {user.EnableGroupchat && (
                                    <div 
                                        className="profile-card community"
                                        onClick={handleOpenInApp}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="profile-card-icon-container">
                                            <GroupchatAvatarView 
                                                hostAvatar={user.ProfilePicture} 
                                                memberAvatars={user.GroupchatMemberAvatars || []} 
                                            />
                                        </div>
                                        <div className="profile-card-text-container">
                                            <h3 className="profile-card-title">👥 Community Chat</h3>
                                            <p className="profile-card-subtitle">
                                                {user.GroupchatMemberCount ? `${user.GroupchatMemberCount} members` : `Meet others who love ${user.FirstName || 'Host'}`}
                                            </p>
                                        </div>
                                        <button 
                                            className="profile-card-btn"
                                            onClick={(e) => { e.stopPropagation(); handleOpenInApp(); }}
                                        >Join</button>
                                    </div>
                                )}

                                {/* Support Card */}
                                {user.SupportLink && (
                                    <div 
                                        className="profile-card donate"
                                        onClick={() => {
                                            if (user.SupportLink) {
                                                const url = user.SupportLink.startsWith('http') ? user.SupportLink : `https://${user.SupportLink}`;
                                                window.open(url, '_blank');
                                            }
                                        }}
                                        style={{ cursor: user.SupportLink ? 'pointer' : 'default' }}
                                    >
                                        <div className="profile-card-icon-container">
                                            <div className="profile-donate-icon-mock">
                                                <img 
                                                    src={require('../images/CoinsHand.png')} 
                                                    alt="Donate" 
                                                    className="profile-donate-image"
                                                />
                                            </div>
                                        </div>
                                        <div className="profile-card-text-container">
                                            <h3 className="profile-card-title">Support</h3>
                                            <p className="profile-card-subtitle">Buy tickets and support events</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* 4. Bio Text Description */}
                        {user.BioText && (
                            <p className="profile-bio-text" onClick={handleOpenInApp} style={{ cursor: 'pointer' }}>{user.BioText}</p>
                        )}

                        {/* 5. Social Icons Row (Frame 1556238039 - Instagram, X, YouTube, TikTok, Website) */}
                        {(user.InstagramAccount || user.TwitterAccount || user.YoutubeAccount || user.TiktokAccount || user.Website) && (
                            <div className="profile-socials-row">
                                {user.InstagramAccount && (
                                    <div 
                                        className="profile-social-item" 
                                        title="Instagram"
                                        onClick={() => {
                                            const handle = cleanSocialHandle(user.InstagramAccount);
                                            const url = `https://www.instagram.com/${handle}`;
                                            window.open(url, '_blank');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <SocialIcon type="instagram" />
                                    </div>
                                )}
                                {user.TwitterAccount && (
                                    <div 
                                        className="profile-social-item" 
                                        title="X (Twitter)"
                                        onClick={() => {
                                            const handle = cleanSocialHandle(user.TwitterAccount);
                                            const url = `https://twitter.com/${handle}`;
                                            window.open(url, '_blank');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <SocialIcon type="twitter" />
                                    </div>
                                )}
                                {user.YoutubeAccount && (
                                    <div 
                                        className="profile-social-item" 
                                        title="YouTube"
                                        onClick={() => {
                                            const yt = user.YoutubeAccount;
                                            const handle = cleanSocialHandle(yt);
                                            const url = yt.startsWith('http') ? yt.trim().replace(/\s+/g, '') : `https://www.youtube.com/@${handle}`;
                                            window.open(url, '_blank');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <SocialIcon type="youtube" />
                                    </div>
                                )}
                                {user.TiktokAccount && (
                                    <div 
                                        className="profile-social-item" 
                                        title="TikTok"
                                        onClick={() => {
                                            const tt = user.TiktokAccount;
                                            const handle = cleanSocialHandle(tt);
                                            const url = tt.startsWith('http') ? tt.trim().replace(/\s+/g, '') : `https://www.tiktok.com/@${handle}`;
                                            window.open(url, '_blank');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <SocialIcon type="tiktok" />
                                    </div>
                                )}
                                {user.Website && (
                                    <div 
                                        className="profile-social-item" 
                                        title="Website"
                                        onClick={() => {
                                            const web = user.Website.trim().replace(/\s+/g, '');
                                            const url = web.startsWith('http') ? web : `https://${web}`;
                                            window.open(url, '_blank');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <SocialIcon type="globe" />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* 6. Action Buttons Row (Frame 1556238049 - Follow & Message Buttons) */}
                        <div className="profile-actions-row">
                            <button className="profile-action-btn follow" onClick={handleOpenInApp}>Follow</button>
                            <button className="profile-action-btn message" onClick={handleOpenInApp}>Message</button>
                        </div>

                        {/* Divider (Line 57) */}
                        <div className="profile-info-divider"></div>

                        {/* 7. Phone & Location Info Section */}
                        <div className="profile-info-rows-container">
                            {user.BusinessPhone && (
                                <div 
                                    className="profile-info-row"
                                    onClick={() => {
                                        const tel = user.BusinessPhone.replace(/[^+\d]/g, '');
                                        window.location.href = `tel:${tel}`;
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="profile-info-left">
                                        <span className="profile-info-icon">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="#9CA4B1">
                                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.7 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                            </svg>
                                        </span>
                                        <span className="profile-info-text">{user.BusinessPhone}</span>
                                    </div>
                                    <span className="profile-info-chevron">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6A7180" strokeWidth="2">
                                            <polyline points="9 18 15 12 9 6" />
                                        </svg>
                                    </span>
                                </div>
                            )}

                            {user.City && (
                                <>
                                    <div className="profile-info-row">
                                        <div className="profile-info-left">
                                            <span className="profile-info-icon">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="#9CA4B1">
                                                    <path d="M12 2a8 8 0 0 0-8 8c0 5.25 8 12 8 12s8-6.75 8-12a8 8 0 0 0-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                                </svg>
                                            </span>
                                            <span className="profile-info-text">{user.City}</span>
                                        </div>
                                        <span className="profile-info-chevron">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6A7180" strokeWidth="2">
                                                <polyline points="9 18 15 12 9 6" />
                                            </svg>
                                        </span>
                                    </div>

                                    {/* 真实的后端生成静态 MapKit 地图图片 - H5 通过接口返回图片 */}
                                    <div className="profile-map-wrapper">
                                        {user.Latitude && user.Longitude ? (
                                            <img 
                                                className="profile-map-image" 
                                                src={`/api/v1/html/profile/${user.ID}/map?size=608x120`} 
                                                alt="Location Map"
                                                onClick={() => {
                                                    const latitude = user.Latitude || 0;
                                                    const longitude = user.Longitude || 0;
                                                    const locationName = user.City || 'Location';
                                                    const encodedLocationName = encodeURIComponent(locationName);
                                                    const urlString = `http://maps.apple.com/?ll=${latitude},${longitude}&z=15&q=${encodedLocationName}`;
                                                    window.open(urlString, '_blank');
                                                }}
                                                onError={(e) => {
                                                    console.error("加载 MapKit 静态地图失败");
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        ) : (
                                            <div className="profile-map-placeholder">
                                                <div className="map-grid-line h1"></div>
                                                <div className="map-grid-line h2"></div>
                                                <div className="map-grid-line v1"></div>
                                                <div className="map-grid-line v2"></div>
                                                <div className="map-pin-pulse"></div>
                                                <div className="map-pin"></div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Divider (Line 58) */}
                        <div className="profile-info-divider"></div>

                        {/* 8. Hosted Events Section (和 iOS 一致：两个都有显示 Tab，单个显示 喇叭emoji+Title) */}
                        {activeWaves.length > 0 ? (
                            <div className="profile-events-section">
                                {hasBoth ? (
                                    /* 双 Tab 切换切换样式 (Deals / Events) */
                                    <div className="profile-events-tabs-header">
                                        <button 
                                            className={`profile-events-tab-btn ${selectedTab === 0 ? 'active' : ''}`}
                                            onClick={() => setSelectedTab(0)}
                                        >
                                            <span className="profile-events-tab-text">{isBusiness ? "Deals" : "Posts"} ({deals.length})</span>
                                            <div className="profile-events-tab-indicator"></div>
                                        </button>
                                        <button 
                                            className={`profile-events-tab-btn ${selectedTab === 1 ? 'active' : ''}`}
                                            onClick={() => setSelectedTab(1)}
                                        >
                                            <span className="profile-events-tab-text">Events ({events.length})</span>
                                            <div className="profile-events-tab-indicator"></div>
                                        </button>
                                    </div>
                                ) : (
                                    /* 单个分类显示：喇叭emoji + title */
                                    <div className="profile-events-title-container">
                                        <span style={{ fontSize: '18px' }}>📢</span>
                                        <h2 className="profile-events-title">
                                            {hasOnlyDeals ? (isBusiness ? 'Deals' : 'Posts') : 'Events'}
                                        </h2>
                                        <span className="profile-events-count">
                                            ({hasOnlyDeals ? deals.length : events.length})
                                        </span>
                                    </div>
                                )}
                                
                                <div className="profile-events-list">
                                    {displayWaves.map((wave, idx) => {
                                        // 决定默认插画背景颜色 (1. 绿色, 2. 紫色, 3. 黄色)
                                        const colorClasses = ['color-green', 'color-purple', 'color-yellow'];
                                        const colorClass = colorClasses[idx % colorClasses.length];

                                        return (
                                            <React.Fragment key={wave.ID}>
                                                <a className="profile-event-card" href={`/event/${wave.ID}`}>
                                                    <div className="profile-event-image-container">
                                                        {/* 图片用背景色代替 - 不渲染图片，使用对应的活动分类彩色插画占位 */}
                                                        <div className={`profile-event-fallback-container ${colorClass}`}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#AADA3F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                                <line x1="16" y1="2" x2="16" y2="6" />
                                                                <line x1="8" y1="2" x2="8" y2="6" />
                                                                <line x1="3" y1="10" x2="21" y2="10" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div className="profile-event-details">
                                                        <h3 className="profile-event-title-text">{wave.Title}</h3>
                                                        <div className="profile-event-tags-row">
                                                            {wave.Distence && wave.Distence.string && (
                                                                <div className="profile-event-tag">
                                                                    <span className="profile-event-tag-icon">
                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA4B1" strokeWidth="2">
                                                                            <path d="M12 2a8 8 0 0 0-8 8c0 5.25 8 12 8 12s8-6.75 8-12a8 8 0 0 0-8-8z" />
                                                                        </svg>
                                                                    </span>
                                                                    <span className="profile-event-tag-text">{wave.Distence.string}</span>
                                                                </div>
                                                            )}
                                                            <div className="profile-event-tag">
                                                                    <span className="profile-event-tag-icon">
                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA4B1" strokeWidth="2">
                                                                            <circle cx="12" cy="12" r="10" />
                                                                            <polyline points="12 6 12 12 16 14" />
                                                                        </svg>
                                                                    </span>
                                                                    <span className="profile-event-tag-text">
                                                                        {calculateDaysLeft(wave.ExpiredAt, wave.IsFake).display}
                                                                    </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                                {idx < displayWaves.length - 1 && <div className="profile-event-divider"></div>}
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : (
                            /* iOS 真实还原：Nothing posted yet 视图 */
                            <div className="profile-empty-events-state">
                                <img 
                                    src={require('../images/NoEventsPostedYet.png')} 
                                    alt="No events" 
                                    className="profile-empty-events-image"
                                />
                                <p className="profile-empty-events-text">Nothing posted yet.</p>
                            </div>
                        )}
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
}
